import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Lottie from "./utils/Lottie";

import AppDevelopment from '../lottie/web_app.json';
import SoftwareSolution from '../lottie/interface.json';
import Testing from '../lottie/code_debug.json';

const styles = theme => ({
    root: {

    },
    serviceContainer1: {
        backgroundColor: '#f2f4fb',
    },
    serviceContainer3: {
        backgroundColor: '#f2f4fb',
    },
    container: {
        width: '90%',
        margin: '0 auto',
    },
    imageSection: {
        padding: '40px',
        [theme.breakpoints.down('sm')]: {
            padding: '10px'
        },
        textAlign: 'center'
    },
    serviceImages: {
        width: '60%',
        height: 'auto',
        padding: '10px',
        [theme.breakpoints.down('sm')]: {
            width: '70%',
            padding: '10px',
        }
    },
    serviceContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        border: '1px #000'
    },
    serviceHeading: {
        margin: '15px 0',
        fontSize: '30px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
    },
    serviceDescription: {
        fontSize: '18px',
        margin: '5px 0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    }
});

const Services = (props) => {
    const { classes } = props;
    return (
        <div className={classes.root}>
            <section className={classes.serviceContainer1}>
                <Grid container spacing={32} className={classes.container}>
                    <Grid container item xs={12} sm={6} md={6} lg={6}>
                        <div className={classes.serviceContent}>
                            <Typography variant="h4" className={classes.serviceHeading}>Web & App Development</Typography>
                            <Typography variant="body1" className={classes.serviceDescription}>In the fast growing digital world, having a website for your business means a huge profit of potential customers. Website and Apps for your business is the best way to market your products and services to the global audience.</Typography>
                            <Typography variant="body1" className={classes.serviceDescription}>We provide web and mobile app development using the power of javascript and technologies like Node.js, React.js and Android.</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <div className={classes.imageSection}>
                            <Lottie animationData={AppDevelopment} />
                        </div>
                    </Grid>
                </Grid>
            </section>
            <section className={classes.serviceContainer2}>
                <Grid container spacing={32} className={classes.container}>
                    <Hidden only={['xs']}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <div className={classes.imageSection}>
                                <Lottie animationData={SoftwareSolution} />
                            </div>
                        </Grid>
                        <Grid container item xs={12} sm={6} md={6} lg={6}>
                            <div className={classes.serviceContent}>
                                <Typography variant="h4" className={classes.serviceHeading}>Software Solution</Typography>

                                <Typography variant="body1" className={classes.serviceDescription}>We are offering progressive end-to-end software solutions. We help deliver your idea from the paper to the markets you desire to reach, be it on Desktops, Tablets or Mobiles.</Typography>
                                <Typography variant="body1" className={classes.serviceDescription}>Our team of developers can convert your idea into reality making the huge difference in the success of the projects.</Typography>
                            </div>
                        </Grid>
                    </Hidden>
                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                        <Grid container item xs={12} sm={6} md={6} lg={6}>
                            <div className={classes.serviceContent}>
                                <Typography variant="h4" className={classes.serviceHeading}>Software Solution</Typography>

                                <Typography variant="body1" className={classes.serviceDescription}>We are offering progressive end-to-end software solutions. We help deliver your idea from the paper to the markets you desire to reach, be it on Desktops, Tablets or Mobiles.</Typography>
                                <Typography variant="body1" className={classes.serviceDescription}>Our team of developers can convert your idea into reality making the huge difference in the success of the projects.</Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <div className={classes.imageSection}>
                                <Lottie animationData={SoftwareSolution} />
                            </div>
                        </Grid>
                    </Hidden>
                </Grid>
            </section>
            <section className={classes.serviceContainer3}>
                <Grid container spacing={32} className={classes.container}>
                    <Grid container item xs={12} sm={6} md={6} lg={6}>
                        <div className={classes.serviceContent}>
                            <Typography variant="h4" className={classes.serviceHeading}>QA and Software Testing</Typography>
                            <Typography variant="body1" className={classes.serviceDescription}>We have been adding Testing and Quality Assurance services to our clients before delivering any projects. Test Automation can have a profound impact on speeding and creating better performance.</Typography>
                            <Typography variant="body1" className={classes.serviceDescription}>Mistakes help one grow, if found and corrected in the right time. We help catch those mistakes before they turn out to be costly and damaging.</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <div className={classes.imageSection}>
                            <Lottie animationData={Testing} />
                        </div>
                    </Grid>
                </Grid>
            </section>
        </div>
    );
}

Services.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Services);